import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import WrappedBillingForm from "./BillingForm";
import WithFormLayout from "../formLayout";
import SummaryContainer from "../SummaryPanel/SummaryContainer";
import { useSignupContext } from "../../../context/SignupContext";
import { fetchCart } from "../../../api/cartAPI.js";
import { useAppContext } from "../../../context/AppContext";
import { updateSignupParams } from "../../../actions/signupActions";
import { GTM_pageview } from "../../../utils/googleTagManager";
import StepLayout from "../../layouts/stepLayout";
import { navigate } from "@reach/router";
import { index } from "../../../utils/constants";

const BillingPanel = () => {
    const {
        state: { loading, signupParams },
        dispatch: signupDispatch,
    } = useSignupContext();

    const {
        state: { loading: cartLoading, cart },
        dispatch,
    } = useAppContext();

    const { items = [] } = cart || {};

    useEffect(() => {
        fetchCart(dispatch).then(() => {
            if (!(cart && items.length > 0)) {
                navigate(index);
            }
        });
        GTM_pageview("Billing | MailChannels", "/pricing/billing");
    }, []);

    return (
        <StepLayout>
            <Helmet>
                <title>{`Billing | MailChannels`}</title>
            </Helmet>
            <WithFormLayout
                loading={Boolean(loading) || Boolean(cartLoading)}
                title={`Add Your Billing Information`}
                subTitle={`All transactions are secure and encrypted.`}
                buttonText={`submit`}
                summary={<SummaryContainer showCoupon={true} />}
            >
                <WrappedBillingForm
                    signupParams={signupParams}
                    onFormsChange={params => signupDispatch(updateSignupParams(params))}
                    updatePreview={() => fetchCart(dispatch)}
                />
            </WithFormLayout>
        </StepLayout>
    );
};

export default BillingPanel;
